import { afterLogin } from '../premium/billingIntent';
import React from 'react'
import './Auth.css'
import loginLogo from "../Assets/carrerup_allInOne_cover_NoBg.png"
import loginLogoIcon from "../Assets/carrerup_profile_NoBg.png"

import { useState } from 'react'
import { postLogin } from '../http/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import {
  setData,
  rememberAuthSession,
  clearRememberedSession
} from '../store/Store'
import Elips from '../components/reusable/Elips'
import ForgotPasswordModal from './ForgotPasswordModal';
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Navigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";


const Login = () => {

  const { t } = useTranslation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);

  const [showForgotModal, setShowForgotModal] = useState(false);

  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (!email) {
      setError(
        t("loginn.emailRequired")
      );
      setLoading(false);
      return;
    }

    if (!password) {
      setError(
        t("loginn.passwordRequired")
      );
      setLoading(false);
      return;
    }

    const userData = {
      data: {
        email: email,
        password: password
      }
    };

    try {

      const response = await postLogin(userData);

      if (response.message === "LOGIN_INCORRECT") {
        setError(
          t("loginn.wrongEmail")
        );
        setLoading(false);
        return;
      }

      if (response.message === "PASSWORD_INCORRECT") {
        setError(
          t("loginn.wrongPassword")
        );
        setLoading(false);
        return;
      }

      if (response.message === "EMAIL_NOT_VERIFIED") {
        setError(
          t("loginn.notVerified")
        );
        setLoading(false);
        return;
      }

      if (response.message === "CONNECTED") {

        const user = {
          id: response.data.user.id,
          role: response.data.user.role,
          username: response.data.user.username,
          language: response.data.user.language,
          isAdmin: response.data.user.isAdmin
        };

        setData("id_user", response.data.user.id);
        setData("token", response.data.token);
        setData("user", user);

        if (rememberMe) {
          rememberAuthSession({
            id_user: response.data.user.id,
            token: response.data.token,
            user
          });
        } else {
          clearRememberedSession();
        }

        const userLanguage =
          response.data.user.language || "fr";

        localStorage.setItem(
          "siteLanguage",
          userLanguage
        );

        i18n.changeLanguage(
          userLanguage
        );

        window.dispatchEvent(
          new Event("carrerup:authenticated")
        );

        navigate('/welcome', { replace: true });

        toast.success(t("loginn.connected"), {
          autoClose: 1700,
        });

      }

    } catch (error) {

      console.error("LOGIN ERROR:", error);

      setError(
        t("loginn.genericError")
      );

    }

    setLoading(false);
  };



  const token = sessionStorage.getItem("token");

  if (token) {
    return <Navigate to={afterLogin()} replace />;
  }


  return (

    <div className="login-page">
      <div className="login-bg">
        <span></span>
        <span></span>
        <span></span>
      </div>

      {!Capacitor.isNativePlatform() && (
        <div className='login-topbar'>
          <a href="/" className="register-back-home">
            {t("loginn.backHome")}
          </a>
        </div>
      )}
      <main className="login-shell">
        <aside className="login-showcase" aria-hidden="true">
          <div className="login-showcase-mark">
            <img src={loginLogoIcon} alt="" />
          </div>
          <span className="login-showcase-kicker">CARRERUP / NETWORK</span>
          <div className="login-showcase-visual">
            <span className="login-visual-node login-visual-node-one" />
            <span className="login-visual-node login-visual-node-two" />
            <span className="login-visual-node login-visual-node-three" />
            <span className="login-visual-core" />
          </div>
          <div className="login-showcase-status">
            <i />
            <span>SPORT CAREER NETWORK</span>
          </div>
        </aside>

        <section className="login-auth-column">
          <form className="login-form" onSubmit={handleLogin}>
            <div className="login-form-heading">
              <img className='login-logo register-logo' src={loginLogo} width={200} alt='CarrerUp' />
              {/* <span>CARRERUP ACCESS</span> */}
              <h1>{t("loginn.button")}</h1>
            </div>

            <div className="login-form-group">
              <label htmlFor="email">{t("loginn.email")}</label>
              <input id="email" name="email" placeholder={
                t("loginn.emailPlaceholder")
              }
                value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="login-form-group">
              <label htmlFor="password">{t("loginn.password")}</label>

              <div className="password-input-container">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder={t("loginn.passwordPlaceholder")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <span
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>
            <label className="login-remember">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(event) => setRememberMe(event.target.checked)}
              />
              <span>{t("loginn.rememberMe")}</span>
            </label>
            <button className='login-button' type="submit" > {loading ? <Elips /> : t("loginn.button")} </button>
            {error &&
              <div className="error-login-message">
                ⚠️ {error}
              </div>
            }
          </form>
          <div className="login-forgot-password">
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                setShowForgotModal(
                  true
                );
              }}
            >

              {t("loginn.forgot")}

            </a>
          </div>
          <div className="login-no-account">
            {t("loginn.newHere")} &nbsp;
            <a href="/register">
              {t("loginn.createAccount")}
            </a>
          </div>
        </section>
      </main>
      <div className='back-to-home'>
      </div>
      {showForgotModal && (
        <ForgotPasswordModal
          onClose={() =>
            setShowForgotModal(
              false
            )
          }
        />
      )}
    </div>
  )
}

export default Login
